import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Termos: React.FC = () => {
  const { t } = useTranslation();
  const updatedAt = new Date('2026-09-26').toLocaleDateString();

  return (
    <div className="min-h-screen">
      <section className="section-padding bg-gray-50">
        <div className="container-custom max-w-3xl">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-primary-600 mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            {t('testimonials.backHome')}
          </Link>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('termsPage.title')}</h1>
          <p className="text-sm text-gray-500 mb-8">{t('termsPage.updatedAt', { date: updatedAt })}</p>

          <div className="card space-y-6 text-gray-700">
            <p>{t('termsPage.intro')}</p>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('termsPage.usageTitle')}</h2>
              <p>{t('termsPage.usage')}</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('termsPage.accountsTitle')}</h2>
              <p>{t('termsPage.accounts')}</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('termsPage.liabilityTitle')}</h2>
              <p>{t('termsPage.liability')}</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('termsPage.changesTitle')}</h2>
              <p>{t('termsPage.changes')}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Termos;
